export default __webpack_public_path__ + "static/media/chevron_bottom.f0a329fb.svg";